<template>
    <a @click.prevent="send" href="#" class="call-tooltip" data-toggle="tooltip" data-placement="bottom" :title="title">
        <slot></slot>
    </a>
</template>
<script>
export default {
    props: {
        title: {
            default: null
        }
    },
    methods: {
        send() {
            this.$alert('Réservé aux <a target="_blank" href="https://etiquettable.eco2initiative.com/abonnements/">abonnements pro</a>', '', {
                dangerouslyUseHTMLString: true,
                callback: action => {
                }
            });
        }
    }
}
</script>